import * as React from 'react';
import { IS_BROWSER } from 'core/constants';
import { useLocation } from '@reach/router';
import { sha256 } from 'lib/util';
import { getClientInfo } from '../../lib/clientInfo';
import usePinterestPixelId from '../../hooks/usePinterestPixelId';
import Pixel from '../Pixel';

export default function PinterestGlobalPixel() {
    const [pixelUrl, setPixelUrl] = React.useState<string | null>(null);
    const location = useLocation();
    const { enabled, pixelId } = usePinterestPixelId();

    React.useEffect(() => {
        const setPixel = async () => {
            const clientInfo = getClientInfo();

            if (!!pixelId && IS_BROWSER) {
                if (clientInfo?.clientEmail) {
                    const hashedEmail = await sha256(clientInfo.clientEmail);
                    const base = 'https://ct.pinterest.com/v3/';
                    // eslint-disable-next-line max-len
                    const queryString = `?tid=${pixelId}&event=init&pd[em]=${hashedEmail}`;
                    const fullUrl = base + queryString;
                    setPixelUrl(fullUrl);
                }
            }
        };

        setTimeout(() => {
            setPixel();
        }, 0);
    }, [location.href, pixelId]);

    if (enabled && pixelUrl) {
        return (
            <Pixel
                aria-hidden={true}
                height="1"
                width="1"
                style={{ display: 'none' }}
                alt="pinterest_tracking_pixel"
                src={pixelUrl}
                cookieType="marketing"
            />
        );
    }

    return null;
}
